(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ── Init all cards via event delegation ── */
(function () {
  'use strict';

  var STORAGE_KEY = 'shopify_wishlist';

  /* ── Helpers ── */
  function getList()       { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; } }
  function saveList(list)  { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }

  /* ── On page load: restore active state for all hearts ── */
  function restoreHearts() {
    var wishlisted = getList().map(function (p) { return String(p.id); });
    document.querySelectorAll('.pc-wishlist[data-product-id]').forEach(function (btn) {
      var pid = String(btn.getAttribute('data-product-id'));
      if (wishlisted.indexOf(pid) !== -1) {
        btn.classList.add('pc-wishlist--active');
      } else {
        btn.classList.remove('pc-wishlist--active');
      }
    });
  }

  /* ── Thumbnail click ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-thumb');
    if (!btn) return;
    var card = btn.closest('.pc-wrap');
    if (!card) return;

    card.querySelectorAll('.pc-thumb').forEach(function (t) {
      t.classList.remove('pc-thumb--active');
    });
    btn.classList.add('pc-thumb--active');

    var heroEl = card.querySelector('.pc-image-wrap .pc-img');
    if (!heroEl) return;

    var newSrc    = btn.dataset.src;
    var newSrcset = btn.dataset.srcset || '';
    if (!newSrc) return;

    heroEl.classList.add('pc-img--fade');
    setTimeout(function () {
      heroEl.onload  = function () { heroEl.classList.remove('pc-img--fade'); heroEl.onload = null; heroEl.onerror = null; };
      heroEl.onerror = function () { heroEl.classList.remove('pc-img--fade'); heroEl.onload = null; heroEl.onerror = null; };
      heroEl.removeAttribute('srcset');
      heroEl.removeAttribute('src');
      if (newSrcset) heroEl.srcset = newSrcset;
      heroEl.src = newSrc;
      if (heroEl.complete && heroEl.naturalWidth > 0) {
        heroEl.classList.remove('pc-img--fade');
      }
    }, 260);
  });

  /* ── Add to Cart ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-atc');
    if (!btn) return;
    pcAddToCart(btn);
  });

  /* ── Wishlist — unified handler ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-wishlist');
    if (!btn) return;

    /* The wishlist section has its own handler for cards inside it */
    if (btn.closest('#wishlist-grid')) return;

    var productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    var isActive = btn.classList.contains('pc-wishlist--active');

    /* pop animation */
    btn.classList.remove('pc-wishlist--pop');
    void btn.offsetWidth; /* reflow */
    btn.classList.add('pc-wishlist--pop');

    if (isActive) {
      /* ── REMOVE from wishlist ── */
      btn.classList.remove('pc-wishlist--active');

      var list = getList().filter(function (p) { return String(p.id) !== String(productId); });
      saveList(list);

      /* Tell wishlist section to remove card */
      var wlCard = document.querySelector('#wishlist-grid [data-wl-id="' + productId + '"]');
      if (wlCard) {
        wlCard.classList.add('removing');
        setTimeout(function () {
          wlCard.remove();
          var grid = document.getElementById('wishlist-grid');
          if (grid) {
            var hasItems = grid.children.length > 0;
            grid.style.display = hasItems ? 'grid' : 'none';
            var emptyEl = document.getElementById('wishlist-empty');
            if (emptyEl) emptyEl.style.display = hasItems ? 'none' : 'flex';
          }
          updateWishlistCount();
        }, 280);
      } else {
        updateWishlistCount();
      }

    } else {
      /* ── ADD to wishlist ── */
      btn.classList.add('pc-wishlist--active');

      /* Collect product data from data-* attributes (no DOM scraping needed) */
      var card      = btn.closest('.pc-wrap');
      var imgEl     = card ? card.querySelector('.pc-image-wrap .pc-img') : null;

      var product = {
        id        : String(productId),
        variantId : btn.getAttribute('data-variant-id') || '',
        title     : btn.getAttribute('data-product-title') || (card ? (card.querySelector('.pc-title') || {}).textContent || '' : ''),
        url       : btn.getAttribute('data-product-url') || '#',
        image     : imgEl ? imgEl.src : '',
        imageAlt  : imgEl ? (imgEl.alt || '') : '',
        price     : btn.getAttribute('data-sale-price') || '',
        compare   : btn.getAttribute('data-compare-price') || '',
      };

      /* Save to localStorage */
      var list2 = getList();
      if (!list2.find(function (p) { return String(p.id) === String(productId); })) {
        list2.push(product);
        saveList(list2);
      }

      /* Push to wishlist section's grid */
      if (typeof window.addWishlistCard === 'function') {
        window.addWishlistCard(product);
      }

      updateWishlistCount();
    }
  });

  /* ── updateWishlistCount — global so wishlist section can call it too ── */
  window.updateWishlistCount = function () {
    var n = getList().length;
    /* pill inside wishlist section */
    var count = document.getElementById('wishlist-count');
    if (count) {
      count.textContent = n;
      count.style.transform = 'scale(1.4)';
      setTimeout(function () { count.style.transform = 'scale(1)'; }, 200);
    }
    /* any header badge */
    var badge = document.getElementById('wishlist-header-count');
    if (badge) badge.textContent = n;
  };

  /* alias for backward compat */
  function updateWishlistCount() { window.updateWishlistCount(); }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreHearts);
  } else {
    restoreHearts();
  }

})();

/* ── Add to Cart ── */
async function pcAddToCart(btn) {
  if (btn.disabled || btn.classList.contains('pc-atc--loading')) return;
  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('pc-atc--ripple');
  setTimeout(function () { btn.classList.remove('pc-atc--ripple'); }, 540);

  btn.disabled = true;
  btn.classList.add('pc-atc--loading');

  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('failed');

    btn.classList.remove('pc-atc--loading');
    btn.classList.add('pc-atc--done');
    pcOpenDrawer();

    setTimeout(function () {
      btn.classList.remove('pc-atc--done');
      btn.disabled = false;
    }, 1800);

  } catch (e) {
    console.error('[pc] cart error', e);
    btn.classList.remove('pc-atc--loading');
    btn.disabled = false;
    var lbl = btn.querySelector('.pc-atc__label');
    var orig = lbl.textContent;
    btn.style.background = '#b92b27';
    lbl.textContent = 'Error – retry';
    setTimeout(function () { btn.style.background = ''; lbl.textContent = orig; }, 2200);
  }
}

/* ── Open cart drawer ── */
function pcOpenDrawer() {
  if (typeof window.openCartDrawer === 'function') {
    window.openCartDrawer();
  }
}
  } catch(e) { console.error(e); }
})();

})();
